export default __webpack_public_path__ + "static/subset-CoFoKak-Black-b588195a4accfafcb4c0f3e39b14adcd.woff2";